// Single source of artwork data, organized by category.
// Images sourced from josephgravesjr.com / gravescollective.com asset CDN.

// Per-artwork extended metadata. Any id not listed defaults to status: "available".
// Update statuses as pieces sell or move into private collections.
export const ARTWORK_META = {
  "lady-in-green": {
    status: "available",
    price: 12000,
    buy_url: "https://square.link/u/dDZpepJg",
    prints_coming_soon: true,
    print_price: 200,
    story:
      "A cowgirl in emerald from crown to hem — wide-brimmed hat, halter gown, hoops catching the light — turned three-quarters away against a quilt of Kente, Ankara, gold leaf, and hand-cut pattern. Magenta hearts stenciled into the corners like a signature. The largest cowgirl in the series and the most composed: she isn't leaving the room, she's deciding whether the room deserves her.",
  },
  "letting-go": {
    status: "available",
    price: 400,
    buy_url: "https://square.link/u/LJUpgELi",
    story:
      "A companion to Reading is Life — the same cowgirl seen from behind, mint hat tilted, sunflower catching the gold light. A road map collaged at the hem. About the small liberties of turning away from a scene that no longer needs you.",
  },
  "birth-of-music": {
    status: "available",
    price: 3200,
    buy_url: "https://square.link/u/Ep9I3VEz",
    story:
      "An early studio piece (2017). A muse rendered in ochre and rose, cradling a hand drum ornamented with a sculptural gold rose. Vintage sheet music and a torn 'Blues Time' clipping are collaged into the ground — the score of everything she carries. About the moment melody arrives in the body before it arrives in the room.",
  },
  "soft-thunder": {
    status: "available",
    price: 3500,
    buy_url: "https://square.link/u/r9F0Bk8T",
    story:
      "A pale horse rendered in pink, cobalt, and gold — half graffiti, half devotional. The damask stencil floating at the top edge marks the sacred; the aerosol drips underneath keep it earthbound. Named for the paradox the animal actually is: thunder in a soft body.",
  },
  "reading-is-life": {
    status: "available",
    price: 2500,
    buy_url: "https://square.link/u/mD73FMcD",
    story:
      "A cowgirl seen from behind — mint hat, sunflower tucked in the brim, hand reaching up to a shelf painted like stained glass. About the quiet radical act of a Black woman reaching for a book, and everything she becomes on the way to it.",
  },
  "native-perspective": {
    status: "sold",
    price: 2000,
    prints_coming_soon: true,
    story:
      "Two figures rendered in the shorthand of the old plains — beadwork, ochre face paint, feathers held mid-drift — brought forward through a modern field of cobalt, teal, and gold. A meditation on who has always been in the picture of the American West, and on the perspective the frontier myth prefers not to hold. Original sold; signed limited-edition prints coming soon — join the studio list to be notified.",
  },
  "pink-cowboy": {
    status: "available",
    price: 15000,
    story:
      "The opening salvo in the Black Western series. A figure caught between costume and identity — the hat that asserts belonging, the silhouette that refuses to apologize for occupying the frame.",
  },
  "posse-krimson": {
    status: "available",
    price: 3500,
    buy_url: "https://square.link/u/tiECLSSi",
    story:
      "The first rider of The Posse — a four-piece meditation on the Black cowboy as a company, not a solitary figure. Krimson lays down the color that binds the crew: dust, blood, and Sunday best all at once.",
  },
  "posse-blue": {
    status: "available",
    price: 3500,
    buy_url: "https://square.link/u/7ee1Yd84",
    story:
      "Second in The Posse. Blue is the quiet one — cool as high-country air, the rider who watches the horizon before anyone else notices it moved.",
  },
  "posse-yellow": {
    status: "available",
    price: 3500,
    buy_url: "https://square.link/u/97mMxkG4",
    story:
      "Third in The Posse. Gold rides in like sunrise — the joyful one, gold leaf and swagger, reminding the crew what they're riding for.",
  },
  "posse-purple": {
    status: "available",
    price: 3500,
    buy_url: "https://square.link/u/wkUeBog6",
    story:
      "The fourth and final rider of The Posse. Purple carries the crown — regal, quiet-eyed, the closer. Together the four hang as a single field: a whole crew reclaiming the frontier in color.",
  },
  "cowboy-named-joe": {
    status: "private-collection",
    family_archive: true,
    story:
      "A portrait of my grandfather, Charles \"Joe\" Graves (b. December 23, 1911) — Army veteran, Appaloosa horseman, and the reason this series exists. Cream hat, bolo tie, blue Western jacket, and the smile from every photograph we have of him. Painted in watercolor in 2021 from the Hugoton, Kansas family archive. Held in the Graves family collection; not for sale.",
  },
  "sunrise-ryder": {
    status: "available",
    price: 20000,
    on_view: "On view · Clayton Hotel & Members Club, 2nd Floor · Denver, CO",
    story:
      "The companion to Mile High Maverick on the Clayton Hotel's second floor — a cowboy in marigold from hat to coat, eyes level with the viewer, set against a sky of knife-cut cobalt and cream. Sunrise as a posture, not a time of day. One of the two largest works currently on public view in Denver; available for acquisition by inquiry.",
  },
  "mile-high-maverick": {
    status: "available",
    price: 15000,
    buy_url: "https://square.link/u/DGDBvWO7",
    on_view: "On view · Clayton Hotel & Members Club, 2nd Floor · Denver, CO",
    story:
      "On view at the Clayton Hotel & Members Club, Denver. A monumental 48-inch canvas — a figure rendered in confident black, framed by burnt-orange sky and the Rockies. Available for acquisition by inquiry.",
  },
  "made-u-look": {
    status: "available",
    price: 3000,
    buy_url: "https://square.link/u/MKbVxZqE",
    story:
      "A masked figure mid-glance — bandana embroidered with paisleys and color, the gaze breaking the fourth wall. Featured at SeeSaw Gallery's solo exhibition In Plain Sight (2025).",
  },
  "frida-in-a-cowboy-hat": {
    status: "available",
    price: 3000,
    story:
      "A border-crossing between two icons — Frida Kahlo and the Western canon. A meditation on who gets to wear the hat, who gets to be remembered, and who decides the rules. Featured at SeeSaw Gallery's solo exhibition In Plain Sight (2025).",
  },
  "leaving-denver": {
    status: "available",
    price: 3500,
    buy_url: "https://square.link/u/wiH5SbXU",
    story:
      "A meditation on departure — the cowboy turning away from the city that raised him, carrying the damask of home in his shoulders.",
  },
  wally: {
    status: "available",
    price: 2000,
    buy_url: "https://square.link/u/yxHDLRV8",
    story:
      "A portrait of a rider in full regalia — buffalo fur, turquoise bolo, mountains held in the lenses. Wally arrives the way a legend arrives: already inside the painting. Exhibited as \"Giddy Up\" at SeeSaw Gallery's solo exhibition In Plain Sight (2025).",
  },
  "me-and-my-dog": {
    status: "available",
    price: 2000,
    buy_url: "https://square.link/u/1GlxMyuy",
    story:
      "Two silhouettes against the dusk — companionship rendered in pink coat, black hat, and the small loyal shadow at his side. About the quiet kind of belonging.",
  },
  "oh-beautiful": {
    status: "available",
    price: 10000,
    buy_url: "https://square.link/u/pBXDCN1x",
    story:
      "A monumental rooster in full color — aerosol, acrylic, and mixed media layered like scripture. A hymn to the small kingdoms that anchor country life.",
  },
  "mile-high-shredder": {
    status: "available",
    price: 4800,
    story:
      "A Denver remix on the cowboy idiom — the same hat, boots, and ride-or-die posture, transposed onto a snowboard against the Rockies. About refusing the binary between cowboy and Coloradan.",
  },
  "cowgirl-line": {
    status: "available",
    price: 2400,
    story:
      "A single-line ink study in the language of Matisse. The cowgirl rendered in continuous gesture — the hat, the gaze, the bandana all carried in one breath.",
  },
  "vagabond-cowboy": {
    status: "available",
    price: 1800,
    story:
      "A loose watercolor field study — the figure emerging from washes of color before the line ever settles. The studio's quickest, most honest mode.",
  },
  "stallion-among-sunflowers": {
    status: "available",
    price: 6800,
    story:
      "A black stallion crowned by mountains and sunflowers — built up with aerosol, acrylic, and mixed media. The animal at the center of the Western myth, painted on its own terms.",
  },
  "holding-grace": {
    status: "available",
    price: 3500,
    buy_url: "https://square.link/u/U4eNhRuv",
    story:
      "Painted in a single session. About letting beauty arrive without grasping at it — the loose strokes are the prayer.",
  },
  "kickin-back": {
    status: "sold",
    price: 400,
    prints_coming_soon: true,
    story:
      "A small, intimate study. The boots and hat doing the storytelling — the body off-stage, resting. Original sold; signed limited-edition prints coming soon — join the studio list to be notified.",
  },
  "black-cowboy": {
    status: "sold",
    story:
      "A monumental silhouette — the figure rendered in absolute black against grey weather, sketched in white shorthand: the hat, the bandana, the belt buckle. Sold from private collection.",
  },
  "cowboy-prince": {
    status: "private-collection",
    story:
      "Acquired by the Central Denver Library (Blair-Caldwell African American Research Library). A figure stepping forward against lavender sky — lasso in hand, the prince of the open frame.",
  },
  cruise: {
    status: "sold",
    story:
      "From the bike-as-horse studies — a Black cowboy on a bicycle, color refusing to sit still. Sold from a 2024 group exhibition.",
  },
  "red-field": {
    status: "available",
    price: 500,
    story:
      "A small intimate work on layered sheet music — a lone figure walking past oil pumps and bison, leaving footprints across a red horizon. The American West, scored.",
  },
  "black-gold": {
    status: "sold",
    story:
      "A sunset, a pumpjack, a man with the whole landscape painted into his back. About inheritance, both earned and extractive. Sold from private collection.",
  },
  "black-domino": {
    status: "available",
    price: 800,
    story:
      "A line drawing in gold against the threshold of two grounds — black above, white below. The body composed of its own outline.",
  },
  "the-ride": {
    status: "private-collection",
    story:
      "From an early body of work — the bicycle stands in for the horse, the cowboy for the kid from the neighborhood.",
  },
  "when-theres-smoke": {
    status: "sold",
    story:
      "A larger work built in layers of newsprint and oil. The captain figure and the smaller witness — about memory passing from one generation to the next. Sold from private collection.",
  },
  "put-on-the-red-dress": {
    status: "sold",
    prints_available: true,
    story:
      "A figure paused mid-gesture. The dress is doing the work the body usually does — color as character. Original sold; signed limited-edition prints available.",
  },
  "girl-on-fire": {
    status: "sold",
    story:
      "A figure striding from a burning city — debris at her feet, the Capitol burning behind her. About the women who carry the weight of what's collapsing, and walk forward anyway.",
  },
  "howdy-darlin": {
    status: "sold",
    story:
      "A study in heat — the cowboy in polka-dot yellow on yellow, paying respects to a small chest in the dust. Quietly funny, quietly somber.",
  },
  "modern-cowboy": {
    status: "on-loan",
    price: 5000,
    on_view:
      "On loan · Contemporary Visions of the West, Daum Museum of Contemporary Art, Sedalia, MO · Aug 12 – Dec 20, 2026",
    on_view_link: "https://www.daummuseum.org/event/contemporary-visions-of-the-west/",
    loan_note:
      "On loan to the Daum Museum of Contemporary Art through December 20, 2026. Reserve the piece now and it ships insured from the studio after the exhibition closes.",
    story:
      "Selected through national jury for Contemporary Visions of the West at the Daum Museum of Contemporary Art (2026), and featured in Daily Camera's review of Black Futures in Art at the Dairy Arts Center. Blue work shirt, chaps, a map of Kansas in the background — the contemporary cowboy at the seam between heritage and now.",
  },
  "colors-of-rory": {
    status: "available",
    price: 2800,
    story:
      "An abstract field of color named for Rory — a small canvas that holds the whole studio's color logic in a single splatter-and-bloom composition.",
  },
  "last-call": {
    status: "available",
    price: 5000,
    story:
      "Originally titled Whiskey Smoke 2 — a still life from the late-night studio. Cigar, glass, and the quiet that follows the bar's last pour. A meditation on what stays after everyone leaves.",
  },
  "last-hope": {
    status: "sold",
    story:
      "Superman in chains under a 'We the People' sky — Daily Planet headlines reading 'White House Surrenders' and 'Superman Saves Nation,' ICE figures crowding the corner. A meditation on the cost of holding the line when the line keeps moving, and on who gets to play the hero in a country still arguing about whose side he's on.",
  },
  "ode-to-hip-hop": {
    status: "available",
    price: 9500,
    buy_url: "https://square.link/u/3oGNlZvj",
    story:
      "An homage to hip hop's birth — August 11, 1973, 1520 Sedgwick Ave, Bronx, at Kool DJ Herc's Back to School Jam. Run-DMC's My Adidas, the boombox, the turntable, the flyers, the cyphers — the architects of the form layered into a single monumental canvas. Built from acrylic, ink, aerosol, and original collage. A cultural anchor piece for serious collectors and hospitality acquisitions.",
  },
  "70s-soul": {
    status: "private",
    story:
      "A love letter to the decade Soul defined Black popular music. Diana Ross luminous at center, the Jackson 5 in the front row, James Brown, Prince mid-fall, Marvin Gaye on the periphery — built from acrylic, original collage, and the warm chromatics of Soul Train. Currently held in a private collection; available for press, museum, and exhibition reference.",
  },
  bowtie: {
    status: "available",
    price: 4200,
    story:
      "The portrait pared down to a face and a single, declarative red. About ritual — getting dressed as an act of self-coronation.",
  },
  "chocolate-honey": {
    status: "sold",
    story:
      "Featured at SeeSaw Gallery's solo exhibition In Plain Sight (2025). Acrylic, aerosol, and map layered into a six-foot canvas — sun on skin, geography embedded in the figure herself. Original sold; prints available.",
    prints_available: true,
  },
  "she-so-pretty": {
    status: "sold",
    story:
      "Painted in 2025. A portrait of looking and being looked at — and refusing both in favor of looking inward.",
  },
  "black-cock": {
    status: "available",
    price: 2400,
    story:
      "A rooster in full plumage, all swagger. The first in a small series studying the animals that pattern Black Western life.",
  },
  "donkey-animals": {
    status: "sold",
    prints_available: true,
    story:
      "From the title alone the painting tells you everything. A childhood wish painted in adulthood. Original sold; signed limited-edition prints available.",
  },
  "donkey-2": {
    status: "sold",
    story:
      "A second donkey portrait — the same childhood wish, returned to in expressionist color. Built up in vivid yellows, magentas, and teal against deep black. Sold from private collection.",
  },
  "sunflower-between-us": {
    status: "sold",
    prints_available: true,
    story:
      "Abstract — a sunflower as the meeting point between two memories. Mixed media, layered like the years. Original sold; signed limited-edition prints available.",
  },
  "sunflower-field": {
    status: "sold",
    prints_available: true,
    story:
      "A field at the edge of becoming abstract. The yellow doing what yellow does. Original sold; signed limited-edition prints available.",
  },
  "marathon-continues": {
    status: "private-collection",
    story:
      "A celebrity interpretation of Nipsey Hussle — the marathon, the Slauson sign, the newsprint testifying around him. Acquired by private collection, 2024.",
  },
  "mj-v-prince": {
    status: "available",
    price: 5000,
    story:
      "Two kings, one canvas. Michael Jackson and Prince painted face-to-face on a 24×48 — the eternal debate rendered in yellow and purple, with Prince's symbol holding the negative space between them.",
  },
  "miles-2-go": {
    status: "sold",
    story:
      "A tribute to Miles Morales — the Brooklyn Spider-Man — built up with comic-book collage, newsprint, and red-and-green sprawl. About representation, mask-lifting, and the Black boy who finally gets to be the hero. Sold from private collection.",
  },
  "major-taylor": {
    status: "available",
    price: 1800,
    story:
      "A watercolor study of Marshall 'Major' Taylor — the first African American world cycling champion (1899). One of the studio's quietest tributes — a portrait of an athlete the canon almost forgot.",
  },
  "sw-the-buffalo": {
    status: "available",
    price: 300,
    buy_url: "https://square.link/u/eQ4JV6VK",
    story:
      "\"You Won't Buff My Flow.\" A buffalo rendered in bold silhouette against a chromatic burst of prairie color — the animal as attitude, holding its ground against the noise of the world. A pocket-scale reminder that some energies were never yours to dim.",
  },
  "sw-the-longhorn": {
    status: "sold",
    price: 200,
    prints_coming_soon: true,
    story:
      "The longhorn portrait — horns like calligraphy across a fever-color ground. Original sold; signed limited-edition prints are being made available. Join the studio list to be notified when they release.",
  },
  "sw-its-hot-out": {
    status: "available",
    price: 200,
    buy_url: "https://square.link/u/foxhLX61",
    story:
      "'It's Hot Out' — a saguaro cactus rising against a gold-leafed sun and washes of desert heat. Small in scale, cinematic in temperature.",
  },
  "sw-cowgirl": {
    status: "sold",
    price: 500,
    prints_coming_soon: true,
    story:
      "\"After Mimosas We Ride.\" A cowgirl mid-ride — the horse in pure silhouette, the rider blooming into color. A weekend anthem in miniature: the brunch, the bandana, the boots, the road. Original sold; signed limited-edition prints coming soon — join the studio list to be notified.",
  },
  "deadwood-dick": {
    status: "available",
    price: 4000,
    story:
      "Nat Love — better known by his dime-novel name, Deadwood Dick — the formerly enslaved Tennessean who out-rode, out-shot, and out-rope-tricked every cowhand at the 1876 Deadwood contest and walked home with the title. Painted from a single lodestar photograph, rendered in oxblood, rose, and the turquoise drip of memory. The West's most decorated cowboy, restored to the canvas.",
  },
};

export function getMeta(id) {
  return ARTWORK_META[id] || { status: "available" };
}

export const ARTWORKS = {
  "black-western": {
    label: "Black Western",
    blurb:
      "Reimagining the American West through the lens of Black cowboys, frontier figures, and untold heritage.",
    items: [
      {
        id: "lady-in-green",
        title: "Lady in Green",
        year: "2025",
        medium: "Acrylic, gold leaf, and mixed-media collage on canvas",
        size: '48" × 60"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/tz845kv6_lady%20in%20green.webp",
      },
      {
        id: "reading-is-life",
        title: "Reading is Life",
        year: "2026",
        medium: "Acrylic on canvas",
        size: '24" × 30"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/whgq6163_Reading%20is%20Life.webp",
      },
      {
        id: "pink-cowboy",
        title: "The Pink Cowboy",
        year: "2024",
        medium: "Acrylic on canvas",
        size: '48" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/8e43o2fp_Pink%20Cowboy.jpg",
      },
      {
        id: "deadwood-dick",
        title: "Deadwood Dick",
        subject: "Nat Love · 1876 Deadwood Rodeo Champion",
        year: "2025",
        medium: "Acrylic on canvas",
        size: '20" × 20"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/rorb7cf8_Deadwood%20Dick.webp",
      },
      {
        id: "cowboy-named-joe",
        title: "Cowboy Named Joe",
        subject: "Charles \"Joe\" Graves · the artist's grandfather",
        year: "2021",
        medium: "Watercolor on paper",
        size: '18" × 24"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/6900ae99cf297fea_Cowboy%20named%20Joe.webp",
      },
      {
        id: "sunrise-ryder",
        title: "Sunrise Ryder",
        year: "2025",
        medium: "Acrylic on canvas",
        size: '48" × 48"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/163ff657f70555ca_Sunrise%20Ryder.jpg",
      },
      {
        id: "mile-high-maverick",
        title: "Mile High Maverick",
        year: "2025",
        medium: "Acrylic, aerosol, and map on canvas",
        size: '48" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/73vyzble_IMG_2799%202.JPG",
      },
      {
        id: "made-u-look",
        title: "Eyes Up Here",
        year: "2025",
        medium: "Acrylic and oil pastel on canvas",
        size: '30" × 30"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/kp0f3qwr_Made%20U%20look.JPG",
      },
      {
        id: "frida-in-a-cowboy-hat",
        title: "Frida in a Cowboy Hat",
        year: "2025",
        medium: "Acrylic on canvas",
        size: '30" × 30"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/0tqyzh9x_Frida.JPG",
      },
      {
        id: "howdy-darlin",
        title: "Howdy Darlin'",
        year: "2024",
        medium: "Acrylic on canvas",
        size: '30" × 30"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/wlyqc7m7_Howdy%20Darlin.jpeg",
      },
      {
        id: "modern-cowboy",
        title: "The Modern Cowboy",
        year: "2025",
        medium: "Acrylic, aerosol, and map on canvas",
        size: '24" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/p7oi7l9k_IMG_2796%202.JPG",
      },
      {
        id: "lets-ride",
        title: "Let's Ride",
        year: "2025",
        medium: "Acrylic and oil pastel on canvas",
        size: '30" × 30"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/5ab5nlsm_IMG_2700.JPG",
      },
      {
        id: "get-lucky",
        title: "Get Lucky",
        year: "2024",
        medium: "Acrylic and ink on canvas",
        size: '24" × 24"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/ntff11du_IMG_0270.jpg",
      },
      {
        id: "vagabond",
        title: "Vagabond",
        year: "2024",
        medium: "Watercolor and ink on paper",
        size: '18" × 24"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/umbd42at_IMG_2857.jpg",
      },
      {
        id: "wally",
        title: "Wally",
        year: "2025",
        medium: "Acrylic on canvas",
        size: '30" × 40"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/cl30rb08_Wallyy.jpg",
      },
      {
        id: "me-and-my-dog",
        title: "Me and My Dog",
        year: "2025",
        medium: "Acrylic on canvas",
        size: '24" × 36"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/jtgkxo2a_Me%20and%20my%20dog.jpg",
      },
      {
        id: "kickin-back",
        title: "Kickin' Back",
        year: "2024",
        medium: "Acrylic & collage on canvas",
        size: '10" × 10"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/08g4w2xr_Kickin%20Back%20.JPG",
      },
      {
        id: "leaving-denver",
        title: "Leaving Denver",
        year: "2025",
        medium: "Acrylic, ink & stencil on canvas",
        size: '48" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/0y73zv75_Leaving%20Denver.JPG",
      },
      {
        id: "holding-grace",
        title: "Holding Grace",
        year: "2025",
        medium: "Acrylic on canvas",
        size: '36" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/zbl5qn3g_Holding%20Grace.JPG",
      },
      {
        id: "black-cowboy",
        title: "Black Cowboy",
        year: "2024",
        medium: "Acrylic on canvas",
        size: '48" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/qhulb79z_Black-Cowboy.jpeg",
      },
      {
        id: "cowboy-prince",
        title: "Cowboy Prince",
        year: "2024",
        medium: "Acrylic on canvas",
        size: '36" × 36"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/0jc64rz0_Cowboy%20Prince.jpeg",
      },
      {
        id: "cruise",
        title: "Cruise",
        year: "2024",
        medium: "Acrylic, oil pastel, and map on canvas",
        size: '24" × 24"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/0xolc4ek_cruise.jpeg",
      },
      {
        id: "red-field",
        title: "Red Field",
        year: "2024",
        medium: "Acrylic and mixed media on sheet music",
        size: '12" × 12"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/m1qy44w3_IMG_0079.JPG",
      },
      {
        id: "black-gold",
        title: "Black Gold",
        year: "2024",
        medium: "Acrylic on canvas",
        size: '36" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/lkny7klt_Black%20Gold.jpeg",
      },
      {
        id: "black-domino",
        title: "Black Domino",
        year: "2024",
        medium: "Acrylic & enamel on panel",
        size: '24" × 24"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/6t4mgcwr_Black%20domino.JPG",
      },
      {
        id: "the-ride",
        title: "The Ride",
        year: "2023",
        medium: "Mixed media on canvas",
        size: '30" × 40"',
        image:
          "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/0zl0u7jt_bike.jpg",
      },
      {
        id: "when-theres-smoke",
        title: "When There's Smoke...",
        year: "2024",
        medium: "Mixed media & collage on canvas",
        size: '48" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/mmv37leb_When%20There%27s%20Smoke....jpg",
      },
    ],
  },
  "figurative-contemporary": {
    label: "Figurative Contemporary",
    blurb:
      "Portraits and figure studies grounded in identity, intimacy, and the everyday rituals of Black life.",
    items: [
      {
        id: "birth-of-music",
        title: "Birth of Music",
        year: "2017",
        medium: "Mixed media on canvas (acrylic, collage, and impasto)",
        size: '24" × 36"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/e9e8zspn_Birth%20of%20Music.webp",
      },
      {
        id: "native-perspective",
        title: "Native Perspective",
        year: "2026",
        medium: "Acrylic on canvas",
        size: '16" × 20"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/nprfd6no_Native%20Perspective.webp",
      },
      {
        id: "major-taylor",
        title: "Major Taylor",
        subject: "Marshall 'Major' Taylor · World Cycling Champion",
        year: "2024",
        medium: "Watercolor and ink on paper",
        size: '18" × 24"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/ohpmb2f3_IMG_3204%202.JPG",
      },
      {
        id: "girl-on-fire",
        title: "Girl on Fire",
        year: "2025",
        medium: "Charcoal and acrylic on canvas",
        size: '18" × 24"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/xt06auye_girl%20on%20fire.JPG",
      },
      {
        id: "last-hope",
        title: "Last Hope",
        subject: "Superman · We the People",
        year: "2025",
        medium: "Acrylic, spray paint, and collage on canvas",
        size: '48" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/u8wgfmmj_last%20hope.JPG",
      },
      {
        id: "ode-to-hip-hop",
        title: "Ode to Hip Hop",
        subject: "1520 Sedgwick Ave · Kool DJ Herc · Run-DMC",
        year: "2023",
        medium: "Acrylic, ink, aerosol, and collage on canvas",
        size: '48" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/75pek7us_Ode%20to%20Hip%20Hop.jpg",
      },
      {
        id: "70s-soul",
        title: "70's Soul",
        subject: "Diana Ross · Jackson 5 · James Brown · Prince · Marvin Gaye",
        year: "2025",
        medium: "Acrylic and collage on canvas",
        size: '30" × 30"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/wr34zbj2_70%27s%20Soul.JPG",
      },
      {
        id: "put-on-the-red-dress",
        title: "Put On the Red Dress",
        year: "2023",
        medium: "Acrylic on canvas",
        size: '24" × 30"',
        image:
          "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/9guy62pq_Put%20On%20the%20Red%20Dress.JPG",
      },
      {
        id: "bowtie",
        title: "Bowtie",
        year: "2024",
        medium: "Acrylic on canvas",
        size: '36" × 36"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/5p3exffv_bowtie.JPG",
      },
      {
        id: "chocolate-honey",
        title: "Chocolate Honey",
        year: "2025",
        medium: "Acrylic, aerosol, and map on canvas",
        size: '60" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/8ysbjnsb_Chocolate%20Honey.JPG",
      },
      {
        id: "she-so-pretty",
        title: "She So Pretty",
        year: "2025",
        medium: "Acrylic on canvas",
        size: '24" × 30"',
        image:
          "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/gzd28o6h_She%20so%20pretty.jpg",
      },
    ],
  },
  animals: {
    label: "Animals",
    blurb:
      "Studies of the creatures that share — and define — the land we call home.",
    items: [
      {
        id: "soft-thunder",
        title: "Soft Thunder",
        year: "2026",
        medium: "Acrylic and aerosol on canvas",
        size: '36" × 48"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/w4u5bav4_Soft%20Thunder.webp",
      },
      {
        id: "black-cock",
        title: "Black Cock",
        year: "2024",
        medium: "Acrylic on canvas",
        size: '36" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/ujshd392_Black%20Cock.jpg",
      },
      {
        id: "oh-beautiful",
        title: "Oh Beautiful",
        year: "2025",
        medium: "Mixed media, acrylic and aerosol on canvas",
        size: '48" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/gqo6zg41_IMG_2701.JPG",
      },
      {
        id: "donkey-animals",
        title: "I Have Always Wanted a Donkey",
        year: "2023",
        medium: "Acrylic on canvas",
        size: '24" × 36"',
        image:
          "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/h8ku13gv_donkey.jpg",
      },
      {
        id: "donkey-2",
        title: "Donkey",
        year: "2024",
        medium: "Acrylic on canvas",
        size: '48" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/7v5e3gu2_donkey.jpg",
      },
    ],
  },
  "abstract-contemporary": {
    label: "Abstract Contemporary",
    blurb:
      "Color, gesture, and rhythm — paintings that hold memory without naming it.",
    items: [
      {
        id: "last-call",
        title: "Last Call",
        year: "2025",
        medium: "Acrylic on canvas",
        size: '24" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/20hahctg_IMG_2801.jpg",
      },
      {
        id: "colors-of-rory",
        title: "Colors of Rory",
        year: "2025",
        medium: "Acrylic and enamel on canvas",
        size: '36" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/wsny3zp5_IMG_3205.JPG",
      },
      {
        id: "sunflower-between-us",
        title: "Sunflower Between Us",
        year: "2024",
        medium: "Mixed media on canvas",
        size: '30" × 30"',
        image:
          "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/53a1jd1p_Sunflower%20Between%20Us.JPG",
      },
      {
        id: "sunflower-field",
        title: "Sunflower Sonata",
        year: "2024",
        medium: "Mixed media on canvas",
        size: '24" × 36"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/7qbxsttf_IMG_7648.jpg",
      },
    ],
  },
  "celebrity-interpretations": {
    label: "Celebrity Interpretations",
    blurb:
      "A private gallery of cultural icons rendered in the language of the studio. Available by inquiry only.",
    items: [
      {
        id: "mj-v-prince",
        title: "MJ v Prince",
        subject: "Michael Jackson & Prince",
        year: "2024",
        medium: "Acrylic on canvas",
        size: '24" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/oidu8e2r_IMG_2837.jpg",
      },
      {
        id: "miles-2-go",
        title: "Miles 2 Go",
        subject: "Miles Morales · Spider-Man",
        year: "2024",
        medium: "Acrylic, ink, and collage on canvas",
        size: '36" × 36"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/e2c8dhvv_IMG_2824.jpg",
      },
      {
        id: "marathon-continues",
        title: "The Marathon Continues",
        subject: "Nipsey Hussle",
        year: "2024",
        medium: "Mixed media & collage on canvas",
        size: '48" × 48"',
        image:
          "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/6fukv246_marathon_continues.jpg",
      },
    ],
  },
  "the-posse": {
    label: "The Posse",
    blurb:
      "A four-piece meditation on the Black cowboy as a crew, not a solitary myth. Krimson, Blue, Gold, and Purple ride together — four monumental 36\" × 48\" canvases built to hang as one cinematic wall. Each rider carries a color that binds the company: dust, quiet, joy, and crown.",
    items: [
      {
        id: "posse-krimson",
        title: "Krimson Cowboy",
        subject: "The Posse · No. 1",
        year: "2025",
        medium: "Acrylic and mixed media on canvas",
        size: '36" × 48"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/5i0nigvj_IMG_1238.webp",
      },
      {
        id: "posse-blue",
        title: "Blue Cowboy",
        subject: "The Posse · No. 2",
        year: "2025",
        medium: "Acrylic and mixed media on canvas",
        size: '36" × 48"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/qi18cw1o_IMG_1239.webp",
      },
      {
        id: "posse-yellow",
        title: "Gold Cowboy",
        subject: "The Posse · No. 3",
        year: "2025",
        medium: "Acrylic and mixed media on canvas",
        size: '36" × 48"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/bhacwads_IMG_1245.webp",
      },
      {
        id: "posse-purple",
        title: "Purple Cowboy",
        subject: "The Posse · No. 4",
        year: "2025",
        medium: "Acrylic and mixed media on canvas",
        size: '36" × 48"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/2yixvhlv_IMG_1247.webp",
      },
    ],
  },
  "small-works": {
    label: "Small Works",
    blurb:
      "Intimate studies from the studio — the West and its creatures rendered at pocket scale. Painted to live on shelves, in reading nooks, and on the walls that ask for less canvas and more punch.",
    items: [
      {
        id: "letting-go",
        title: "Letting Go",
        year: "2026",
        medium: "Acrylic and mixed media on canvas",
        size: '10" × 10"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/xcx111fw_Letting%20Go.webp",
      },
      {
        id: "sw-the-buffalo",
        title: "You Won't Buff My Flow",
        year: "2025",
        medium: "Acrylic and mixed media on canvas",
        size: '12" × 12"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/2ld8bysl_IMG_2197.webp",
      },
      {
        id: "sw-cowgirl",
        title: "After Mimosas We Ride",
        year: "2025",
        medium: "Acrylic and mixed media on canvas",
        size: '12" × 12"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/bfd76brz_IMG_2192.webp",
      },
      {
        id: "sw-its-hot-out",
        title: "It's Hot Out",
        subject: "The Cactus",
        year: "2025",
        medium: "Acrylic, aerosol, gold leaf, and map on canvas",
        size: '10" × 10"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/cogjccpq_IMG_2193.webp",
      },
      {
        id: "sw-the-longhorn",
        title: "The Longhorn",
        year: "2025",
        medium: "Acrylic and mixed media on canvas",
        size: '10" × 10"',
        image:
          "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/h85fkr3x_IMG_2195.webp",
      },
    ],
  },
};

export const WORK_CATEGORIES = [
  { slug: "black-western", label: "Black Western" },
  { slug: "the-posse", label: "The Posse" },
  { slug: "figurative-contemporary", label: "Figurative Contemporary" },
  { slug: "animals", label: "Animals" },
  { slug: "abstract-contemporary", label: "Abstract Contemporary" },
  { slug: "small-works", label: "Small Works" },
  { slug: "celebrity-interpretations", label: "Celebrity Interpretations" },
];

// Recent placements — for the discreet "Recently placed" strip on Home / About.
// Add new entries at the top when a piece sells. Keep it tasteful — no buyer names, cities only.
export const RECENT_PLACEMENTS = [
  {
    title: "The Marathon Continues",
    detail: "Private collection · Los Angeles, CA",
    when: "Nov 2025",
    slug: "celebrity-interpretations",
    id: "marathon-continues",
  },
  {
    title: "Black Cowboy",
    detail: "Private collection · Denver, CO",
    when: "Aug 2025",
    slug: "black-western",
    id: "black-cowboy",
  },
];

// Shop dropdown / footer — Black Cowboys Exist (BCE) merch + direct Square Payment Links.
// Add new entries here to have them appear in the Shop nav dropdown and footer.
export const SHOP_ITEMS = [
  {
    label: "Limited Edition Prints",
    href: "https://square.link/u/on7168uU",
    group: "Prints",
  },
  {
    label: "You Are An Artist (book)",
    href: "https://square.link/u/YQ0DsXP7",
    group: "Books",
  },
  {
    label: "BCE Hats",
    href: "https://gravescollective.com",
    group: "Black Cowboys Exist",
  },
  {
    label: "BCE T-shirt",
    href: "https://gravescollective.com",
    group: "Black Cowboys Exist",
  },
  {
    label: "BCE Patch",
    href: "https://gravescollective.com",
    group: "Black Cowboys Exist",
  },
  {
    label: "BCE Sticker",
    href: "https://gravescollective.com",
    group: "Black Cowboys Exist",
  },
];

export const FAMILY_ARCHIVE = {
  eyebrow: "Family Archive · Where it comes from",
  title: "Three generations",
  titleItalic: "in hats.",
  intro:
    "Before Black Western was a series, it was a family. These two photographs were taken in Hugoton, Kansas, in 1984 and ’85 — Kansas cowboys, show horses, rodeo Sundays, and a grandfather who made sure the next two generations knew how to sit a saddle.",
  photos: [
    {
      id: "three-joes",
      src: "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/edf8435716d21beb_3%20Joes.webp",
      alt: "Joseph H. Graves Sr., a young Joseph H. Graves Jr., and Charles \"Joe\" Graves in white cowboy hats beside a pickup truck",
      caption: "Joseph H. Graves Sr. · Joseph H. Graves Jr. · Charles \"Joe\" Graves",
      meta: "Hugoton, Kansas · 1984–85 · family archive",
    },
    {
      id: "jerry-and-joe",
      src: "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/3a9ba312b525b619_these%20cowboys.jpg",
      alt: "Jerry Graves and Charles \"Joe\" Graves in matching black embroidered Western shirts beside a horse trailer",
      caption: "Jerry Graves · Charles \"Joe\" Graves",
      meta: "Hugoton, Kansas · 1984–85 · family archive",
    },
  ],
  grandfather: [
    "United States Army veteran.",
    "Broke and trained Appaloosa show horses.",
    "Worked notable horses for the movies, including The Lone Ranger.",
    "Cousin to the photographer and filmmaker Gordon Parks.",
  ],
  portrait: { slug: "black-western", id: "cowboy-named-joe", title: "Cowboy Named Joe" },
  notice: "Family archive · These photographs are not for sale or reproduction.",
};

export const GIFT_CARDS = [
  {
    amount: "$25",
    image:
      "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/51gth7x5_Giftcard%2025%24.png",
    blurb: "A handsome introduction — a print, a book, a tee.",
  },
  {
    amount: "$500",
    image:
      "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/0apqqi47_Giftcard%20500%24.png",
    blurb: "Generous. A serious collector's head start.",
  },
];
export const GIFT_CARD_URL = "https://gravescollective.com/gift-cards";
export const LIMITED_EDITIONS_URL = "https://square.link/u/on7168uU";

// Curator Collections — hand-picked and dynamic groupings across every series.
// `filter` returns true for pieces that belong; keeps collections in sync with
// ARTWORKS / ARTWORK_META edits without duplicating any data.
export const COLLECTIONS = [
  {
    slug: "prints-available",
    label: "Available as Prints",
    eyebrow: "Curator Collection · Signed Editions",
    blurb:
      "Paintings that live a second life as signed, numbered limited-edition prints — most originals are already in private collections; a few are still available. Museum-grade archival paper, printed and hand-signed in Denver. If a print is marked \"coming soon,\" join the studio list to be notified when it releases.",
    filter: ({ meta }) => meta.prints_available === true || meta.prints_coming_soon === true,
  },
  {
    slug: "under-5k",
    label: "$5,000 and Under",
    eyebrow: "Curator Collection · Entry Point",
    blurb:
      "For the first serious painting. Available originals at $5,000 and under — no compromise on scale or presence, just the studio's most approachable price band.",
    filter: ({ meta }) =>
      meta.status === "available" && typeof meta.price === "number" && meta.price <= 5000,
  },
  {
    slug: "for-the-office",
    label: "For the Office",
    eyebrow: "Curator Collection · Boardroom & Lobby",
    blurb:
      "Statement pieces built for corporate walls — monumental scale, confident presence, and rooted in Black American iconography. Ideal for headquarters, hotels, and executive suites.",
    curated: [
      "sunrise-ryder",
      "mile-high-maverick",
      "pink-cowboy",
      "leaving-denver",
      "oh-beautiful",
      "stallion-among-sunflowers",
      "modern-cowboy",
      "wally",
      "soft-thunder",
    ],
  },
  {
    slug: "new-this-year",
    label: "New This Year",
    eyebrow: `Curator Collection · ${new Date().getFullYear()} Studio`,
    blurb:
      "Everything painted in the current studio year. What's still wet, what's just landed, and what's headed to the next show.",
    filter: ({ piece, meta }) =>
      piece.year === String(new Date().getFullYear()) && meta.status !== "sold" && meta.status !== "private-collection",
  },
];

// Available originals grouped by series, in WORK_CATEGORIES order. Powers /originals.
export function getAvailableOriginalsBySeries() {
  return WORK_CATEGORIES.map((c) => {
    const series = ARTWORKS[c.slug];
    const items = (series?.items || []).filter((a) =>
      ["available", "on-loan"].includes(getMeta(a.id).status)
    );
    return { slug: c.slug, label: c.label, blurb: series?.blurb, items };
  }).filter((s) => s.items.length > 0);
}

// Flatten helper: returns every piece across every series with its meta + series slug.
export function getAllPieces() {
  const out = [];
  for (const [slug, series] of Object.entries(ARTWORKS)) {
    for (const piece of series.items) {
      out.push({ piece, meta: getMeta(piece.id), seriesSlug: slug, seriesLabel: series.label });
    }
  }
  return out;
}

export function getCollectionBySlug(slug) {
  return COLLECTIONS.find((c) => c.slug === slug);
}

export function getCollectionPieces(collection) {
  const all = getAllPieces();
  if (collection.curated) {
    const order = collection.curated;
    return all
      .filter((p) => order.includes(p.piece.id))
      .sort((a, b) => order.indexOf(a.piece.id) - order.indexOf(b.piece.id));
  }
  if (typeof collection.filter === "function") {
    return all.filter(collection.filter);
  }
  return [];
}

export const EXHIBITIONS = {
  upcoming: [
    {
      id: "daum-contemporary-visions",
      title: "Contemporary Visions of the West",
      badge: "Museum Exhibition · Juried",
      meta: "August 12 – December 20, 2026",
      location:
        "Daum Museum of Contemporary Art · 3201 W 16th St, Sedalia, MO 65301",
      blurb:
        "A nationally juried museum exhibition bringing together artists from across the United States whose work reclaims and reimagines Western identities and landscapes beyond nostalgia and stereotype. The Modern Cowboy is on view.",
      featuring: { id: "modern-cowboy", slug: "black-western", title: "The Modern Cowboy" },
      image:
        "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/3f35b086f1fc2103_Exhibition%20Card%20Front%20%281%29.png",
      link: "https://www.daummuseum.org/event/contemporary-visions-of-the-west/",
      calendar: {
        start: "2026-08-12",
        end: "2026-12-21",
        allDay: true,
      },
    },
    {
      id: "black-futures",
      title: "Black Futures In Art",
      badge: "Group Exhibition",
      meta: "May 15 · 6–8 PM · Opening Reception",
      location:
        "Lafayette Arts & Cultural Resources · 201 N. Public Rd, Lafayette, CO 80026",
      blurb:
        "Genome Speaks What Erasure Cannot Silence — a group exhibition in partnership with Climate Justice Hive. On view May 14 – July 12, 2026.",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/tdzsvuzr_black%20futures%20in%20art%20flyer.JPG",
      link: null,
      calendar: {
        start: "2026-05-15T18:00:00",
        end: "2026-05-15T20:00:00",
        allDay: false,
      },
    },
    {
      id: "tonantzin-solo",
      title: "Softpower / Hard Lines",
      badge: "Solo Exhibition",
      meta: "First Friday · June 5 · 5:30–8 PM",
      location: "Tonantzin Casa de Café · 915 Santa Fe Drive, Denver, CO 80204",
      blurb:
        "A solo presentation on the Santa Fe Arts District corridor — new figurative and Black Western works that hold the line between tenderness and resolve.",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/7dot45md_tantzin%20cafe.JPG",
      link: null,
      calendar: {
        start: "2026-06-05T17:30:00",
        end: "2026-06-05T20:00:00",
        allDay: false,
      },
    },
    {
      id: "tilting-west",
      title: "Tilting West",
      badge: "Group Exhibition",
      meta: "June 4 – August 23, 2026",
      location: "AC Galleries · Home of Colorado Artists",
      blurb:
        "A regional group exhibition reframing the iconography of the American West — Colorado artists in conversation with land, myth, and inheritance.",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/ie1gs7qp_Screenshot%202026-05-14%20at%207.35.03%E2%80%AFPM.png",
      link: null,
      calendar: {
        start: "2026-06-04",
        end: "2026-08-24",
        allDay: true,
      },
    },
    {
      id: "pearl-street",
      title: "Boulder Pearl Street Arts Festival",
      badge: "Festival",
      meta: "July 18–20",
      location: "Pearl Street, Boulder, CO",
      blurb:
        "Three days of public-facing work — meet the artist, see new pieces in person, and acquire originals and limited-edition prints on the street.",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/73vyzble_IMG_2799%202.JPG",
      link: null,
      calendar: {
        start: "2026-07-18",
        end: "2026-07-21",
        allDay: true,
      },
    },
  ],
  current: [
    {
      id: "clayton",
      title: "Clayton Hotel",
      meta: "Currently on Display",
      location: "Clayton Hotel & Members Club · 2nd Floor — Denver, CO",
      blurb:
        'On view: "Mile High Maverick" (48"×48") and "Sunrise Ryder" (48"×48") — two large-scale Black Western works currently on display. Both are available for acquisition by inquiry.',
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/73vyzble_IMG_2799%202.JPG",
      link: "https://maps.google.com/?q=Clayton+Hotel+Denver",
    },
    {
      id: "central-denver-library",
      title: "Central Denver Library",
      meta: "Public Collection",
      location:
        "Blair-Caldwell African American Research Library · Denver, CO",
      blurb:
        '"Cowboy Prince" was acquired by the Central Denver Library for its permanent collection — visible by the public during normal hours.',
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/0jc64rz0_Cowboy%20Prince.jpeg",
      link: "https://maps.google.com/?q=Blair-Caldwell+African+American+Research+Library+Denver",
    },
    {
      id: "maes",
      title: "Mae's Gallery",
      badge: "Solo Exhibition",
      meta: "On view — by appointment",
      location: "3575 Chestnut Pl, Denver, CO",
      blurb:
        "A solo exhibition tracing the throughline between figurative work and the Black Western series — a meditation on inheritance, land, and the body.",
      image:
        "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/9guy62pq_Put%20On%20the%20Red%20Dress.JPG",
      link: null,
    },
  ],
  past: [
    {
      id: "knoll",
      title: "Not Another Black Art Show",
      venue: "Niza Knoll Gallery",
      address: "915 Santa Fe Dr",
      dates: "May 30 – June 29, 2025",
      note: "Artist Reception & Panel Discussion",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/mmv37leb_When%20There%27s%20Smoke....jpg",
    },
    {
      id: "memento",
      title: "High Noon — Group Show",
      venue: "Memento Mori Gallery",
      address: "6451 W Colfax Ave, Lakewood CO",
      dates: "Jan 3 – 25, 2025",
      note: "Group exhibition",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/lkny7klt_Black%20Gold.jpeg",
    },
    {
      id: "bhm",
      title: "BHM — Group Show",
      venue: "Charlie Cousins Gallery",
      address: "Blair-Caldwell African American Research Library, Denver CO",
      dates: "Feb 5 – Mar 11, 2025",
      note: "Black History Month group exhibition",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/5p3exffv_bowtie.JPG",
    },
    {
      id: "in-plain-sight",
      title: "In Plain Sight: a celebration of Black cowboys",
      venue: "SeeSaw Gallery",
      address: "5 W. Radcliff Ave, Englewood CO 80110",
      dates: "Nov 15, 2025 – Jan 18, 2026",
      note: "Solo exhibition · Reviewed in DARIA Magazine",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/ngp0y5mv_Black-Cowboy.jpeg",
    },
    {
      id: "black-futures-2026",
      title: "Black Futures in Art 2026",
      venue: "Dairy Arts Center · McMahon Gallery",
      address: "Boulder, CO · Curated by Adderly Grant-Lord",
      dates: "Through March 29, 2026",
      note: "Group exhibition · Reviewed in Daily Camera",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/0y73zv75_Leaving%20Denver.JPG",
    },
  ],
};

export const PRESS = [
  {
    outlet: "North Forty News",
    title: "Colorado 150 Art Honors Mountains, Dearfield",
    author: "North Forty News Staff",
    date: "September 29, 2026",
    link: "https://northfortynews.com/category/art-lifestyle/colorado-150-art-honors-mountains-dearfield/",
    pull: "\u201cDearfield\u2019s story is one of courage, and this painting makes sure Coloradans never forget it,\u201d Gov. Jared Polis said. \u2026 \u201cBlack history is Colorado history, and I\u2019m proud to help put that story back on the landscape,\u201d Graves said.",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/5f26a7b97c3dcde4_IMG_3694.JPG",
    featured: true,
  },
  {
    outlet: "Daily Camera",
    title:
      "Black Futures in Art 2026 returns to the Dairy Arts Center Boulder",
    author: "Ella Cobb",
    date: "February 28, 2026",
    link: "https://www.dailycamera.com/2026/02/28/black-futures-in-art-dairy-arts-center-boulder/",
    pull: "Denver-based artist Joseph Graves Jr., a painter and educator featured in this year's lineup, brings a looseness and lightness to the exhibition. His creative practice operates as an exercise in freedom — favoring honest expression and a license to play over rigid formalism.",
    image:
      "https://www.dailycamera.com/wp-content/uploads/2026/02/DCC-L-FUTURES_2MJ6687.jpg",
  },
  {
    outlet: "DARIA — Denver Art Review",
    title:
      "In Plain Sight: a celebration of Black cowboys",
    author: "Kamden Hilliard",
    date: "December 16, 2025",
    link: "https://www.dariamag.com/home/in-plain-sight",
    pull: "Graves rectifies this landscape with bombastic, beautiful, and Black figures of vision and excellence. He renders the past to make space for its echoes into the present and future of art and life in the American West.",
  },
  {
    outlet: "Cherry Creek Magazine",
    title: "Artist in Residence: Meet Joseph Graves, Jr.",
    author: "Cherry Creek Magazine",
    date: "January 26, 2024",
    link: "https://cherrycreekmag.com/artist-in-residence-2/",
    pull: "He's as authentic and down-to-earth as his artwork would imply — possessing a fascinating story of various chapters in life, from law school and the legal sector, to on stage as an award-winning actor, writer, acting coach, singer and artist.",
  },
  {
    outlet: "Shoutout Colorado",
    title: "Meet Joseph Graves · Artist & Educator",
    author: "Shoutout Colorado",
    date: "2025",
    link: "https://shoutoutcolorado.com/meet-joseph-graves-artist-educator/",
    pull: "Art isn't just something I do — it's something I am. It connects me to my past, my family, and my purpose.",
  },
];

export const REPRESENTATION = [
  {
    name: "Artsy",
    role: "Artist Profile · Represented by SeeSaw Gallery",
    link: "https://www.artsy.net/artist/joseph-graves-jr",
  },
  {
    name: "RiNo Art District",
    role: "Featured Artist",
    link: "https://rinoartdistrict.org/artist/joseph-graves-jr",
  },
  {
    name: "SeeSaw Gallery",
    role: "Gallery Representation · Englewood, CO",
    link: "https://www.seesawart.com/",
  },
];

export const SERVICES = [
  {
    title: "Art Lessons",
    blurb: "Saturday youth workshops (ages 8–12) in Denver, plus private and small-group lessons for adults.",
    link: "/youth-art-classes",
    internal: true,
  },
  {
    title: "Daddy Joe's Cowboy Capers",
    blurb: "Youth programming connecting craft, story, and Western heritage.",
    link: "/contact?subject=Daddy%20Joe%27s%20Cowboy%20Capers%20%C2%B7%20Inquiry&message=Hello%20%E2%80%94%20I%27m%20interested%20in%20booking%20Daddy%20Joe%27s%20Cowboy%20Capers.%20Date%20/%20location%20/%20group%20size%3A%20",
    internal: true,
  },
  {
    title: "Live Event Painting",
    blurb: "On-site painting for weddings, openings, and corporate events. Quoted per event; 25% deposit holds your date.",
    link: "/live-painting",
    internal: true,
  },
  {
    title: "Live iPad Drawings",
    blurb: "Digital live-portrait sessions for activations and pop-ups.",
    link: "/contact?subject=Live%20iPad%20Drawings%20%C2%B7%20Inquiry&message=Hello%20%E2%80%94%20I%27m%20interested%20in%20booking%20Live%20iPad%20Drawings.%20Date%20/%20location%20/%20group%20size%3A%20",
    internal: true,
  },
  {
    title: "Face Painting",
    blurb: "Festival and private-event face painting for all ages.",
    link: "/contact?subject=Face%20Painting%20%C2%B7%20Inquiry&message=Hello%20%E2%80%94%20I%27m%20interested%20in%20booking%20Face%20Painting.%20Date%20/%20location%20/%20group%20size%3A%20",
    internal: true,
  },
  {
    title: "Photography",
    blurb: "Editorial and event photography by Joseph and the studio.",
    link: "/contact?subject=Photography%20%C2%B7%20Inquiry&message=Hello%20%E2%80%94%20I%27m%20interested%20in%20booking%20Photography.%20Date%20/%20location%20/%20group%20size%3A%20",
    internal: true,
  },
  {
    title: "Bob'Bae Rosé · Paint n Sip",
    blurb:
      "Two-hour Paint n Sip parties hosted in character by Bob'Bae Rosé — at the studio or your venue. From $50/person.",
    link: "/paint-n-sip",
    internal: true,
  },
  {
    title: "Purchase Clothing",
    blurb: "The Graves Collective — limited apparel, books, and studio merchandise.",
    link: "https://gravescollective.com/apparel",
  },
];

export const COLLECTORS = {
  featured: [
    {
      id: "anderson-jackson",
      names: ["Anthony Anderson", "Dallas Jackson"],
      role: "Actor / Producer · Writer / Producer",
      occasion: "BRIC 5 Year Anniversary",
      blurb:
        "Anthony Anderson and Dallas Jackson received framed Joseph Graves Jr. prints at the BRIC (Black Resilience in Colorado) 5 Year Anniversary — a recognition of Black-led work building community, culture, and accountability across Colorado.",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/rb8olmjo_IMG_8497.JPG",
    },
  ],
  walls: [
    {
      id: "wall-1",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/ven8h67q_F4CAB1AD-E1C1-4531-9A6C-98964493ECF8.jpeg",
      caption: "Opening night · with collectors",
      context: "Denver, CO",
    },
    {
      id: "wall-2",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/92i348be_728226803409866660.jpeg",
      caption: "At home with a large-scale figurative work",
      context: "Private collection · Denver",
    },
    {
      id: "wall-3",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/m28qdwtm_IMG_8819.jpeg",
      caption: "Collector reception — the three cowboys",
      context: "Gallery acquisition",
    },
    {
      id: "wall-4",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/190gj9to_79FA844E-F916-40C6-8764-B4209BC45937.jpeg",
      caption: "A small treasure, well-placed",
      context: "Private collection",
    },
    {
      id: "wall-5",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/vl477ur2_IMG_8434.jpeg",
      caption: "Studio pickup · sunflowers heading home",
      context: "Private collection",
    },
  ],
  notableCollections: [
    "Clayton Hotel — Denver, CO (permanent installation)",
    "Blair-Caldwell African American Research Library — Denver, CO",
    "Niza Knoll Gallery — Denver, CO",
    "Mae's Gallery — Denver, CO",
    "Private collections across Denver, Los Angeles, and Atlanta",
  ],
  testimonials: [
    {
      quote:
        "Joseph's work doesn't just hang on the wall — it changes the room. We've had guests stop in the hallway just to stand with it.",
      attribution: "Clayton Hotel — Hospitality Partner",
    },
    {
      quote:
        "I bought my first Joseph Graves piece three years ago. I now have four. There's a quiet, insistent integrity in everything he makes.",
      attribution: "Private collector — Denver, CO",
    },
    {
      quote:
        "His Black Western series reframed what I thought the genre could carry. Essential work for any collection that takes contemporary Western seriously.",
      attribution: "Curator — Front Range, CO",
    },
  ],
};

export const STUDIO_VISIT = {
  hours: "Wednesday evenings · 5:00 – 8:00 PM",
  location: "Studio — Denver, Colorado (address shared upon confirmation)",
  notes:
    "Studio visits are by appointment only. Wednesday evenings are reserved for serious collectors, curators, and press. Please share what you'd like to see; the studio will confirm within 48 hours.",
};

export const BOOKS = [
  {
    id: "you-are-an-artist",
    title: "You Are An Artist",
    role: "Written & Illustrated by Joseph Graves Jr.",
    year: "2025",
    format: "Softcover",
    blurb:
      "A new picture book affirming every child as a creator. Written and illustrated by Joseph Graves Jr., it follows a father and son discovering the artist already living inside them.",
    cover:
      "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/kx0mn03b_Cover.png",
    link: "https://square.link/u/YQ0DsXP7",
    badge: "New",
  },
  {
    id: "daddy-joes-cowboy-capers",
    title: "Daddy Joe's Cowboy Capers",
    role: "Written & Illustrated by Joseph Graves Jr.",
    year: "Award-winning",
    format: "Hardback",
    blurb:
      "An award-winning children's book celebrating Black Western heritage through the adventures of Daddy Joe — connecting craft, story, and cowboy culture for young readers.",
    cover:
      "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/h0qsals1_Cowboy%20capers.jpg",
    link: "https://gravescollective.com/products/daddy-joes-cowboy-capers",
    badge: "Award-winning",
  },
];

export const MURALS = {
  intro:
    "Public-facing work and large-scale wall paintings across Denver and the Front Range. Mural commissions accepted for residences, hospitality spaces, and community projects.",
  works: [
    {
      id: "dearfield-jackson-lake",
      title: "Dearfield",
      year: "2026",
      location: "Jackson Lake State Park · Orchard, CO",
      commission:
        "Unveiled by Governor Jared Polis as part of the Colorado 150 statehood celebration",
      press: {
        outlet: "North Forty News",
        quote: "Dearfield\u2019s story is one of courage, and this painting makes sure Coloradans never forget it.",
        attribution: "Gov. Jared Polis",
        link: "https://northfortynews.com/category/art-lifestyle/colorado-150-art-honors-mountains-dearfield/",
      },
      story:
        "Painted across the entrance station at Jackson Lake State Park, a few miles from the site of Dearfield — the Black homesteading colony founded by O.T. Jackson in 1910. A cowboy and his horse, a suited founder, and an elder in white against the Front Range sunset, the gold of the plains winding through all three. Governor Polis unveiled the mural with park staff, Dearfield descendants, and community in attendance.",
      image:
        "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/5f26a7b97c3dcde4_IMG_3694.JPG",
      gallery: [
        {
          src: "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/46f0fa7cce7c0fb1_IMG_3692.JPG",
          caption: "Joseph signing the wall as Governor Polis looks on",
        },
        {
          src: "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/8e9193a196f6fe3d_IMG_3686.JPG",
          caption: "The artist before the finished mural",
        },
        {
          src: "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/af52d23262c73ff5_IMG_3695.JPG",
          caption: "Governor Polis in conversation at the unveiling",
        },
        {
          src: "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/47c483e9c55be570_IMG_3696.JPG",
          caption: "Park staff, descendants, and community at Jackson Lake",
        },
      ],
    },
    {
      id: "8z-larimer",
      title: "8z Real Estate Mural",
      year: "2025",
      location: "2865 Larimer St · RiNo Arts District, Denver, CO",
      commission: "Commissioned by 8z Real Estate",
      image:
        "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/n4rwv6qh_DJI_20260119_113247_139.JPG",
    },
  ],
};

export const SEESAW_WORKS = [
  {
    title: "No Laughing Matter",
    year: "2025",
    medium: "Acrylic, aerosol, and map on canvas",
    size: '24" × 48"',
  },
  {
    title: "Giddy Up",
    year: "2025",
    medium: "Mixed media, acrylic, aerosol, and map on canvas",
    size: '40" × 30"',
  },
  {
    title: "Coven",
    year: "2025",
    medium: "Acrylic on canvas",
    size: '9" × 9"',
  },
  {
    title: "Teeter Totter",
    year: "2025",
    medium: "Mixed media, acrylic, map, and aerosol on canvas",
    size: '10" × 20"',
  },
];

export const CV = {
  born: "b. 1979",
  basedIn: "Lives and works in Denver, Colorado",
  education: [
    {
      year: "",
      detail: "Professional Certificate · Harvard College",
    },
    {
      year: "2005",
      detail: "Legal Administration · University of Denver Sturm College of Law",
    },
    {
      year: "",
      detail:
        "B.S., Political Science · University of Colorado Boulder / Denver",
    },
  ],
  soloExhibitions: [
    {
      year: "2025",
      title: "In Plain Sight: a celebration of Black cowboys",
      venue: "SeeSaw Gallery · Englewood, CO",
      note: "Nov 15, 2025 – Jan 18, 2026 · Reviewed in DARIA Magazine",
    },
    {
      year: "2025",
      title: "Solo Exhibition — Tonantzin Casa De Café",
      venue: "915 Santa Fe Drive · Denver, CO",
      note: "First Friday · June 6, 2025",
    },
    {
      year: "2025",
      title: "Mae's Gallery Solo Exhibition",
      venue: "3575 Chestnut Pl · Denver, CO",
    },
  ],
  groupExhibitions: [
    {
      year: "2026",
      title: "Contemporary Visions of the West",
      venue: "Daum Museum of Contemporary Art · Sedalia, MO",
      note: "Nationally juried · Aug 12 – Dec 20, 2026 · The Modern Cowboy",
      link: "https://www.daummuseum.org/event/contemporary-visions-of-the-west/",
    },
    {
      year: "2026",
      title: "Black Futures in Art 2026",
      venue:
        "Dairy Arts Center · Boulder, CO · Curated by Adderly Grant-Lord",
      note: "February – March 2026 · Reviewed in Daily Camera",
    },
    {
      year: "2026",
      title: "Tilting West",
      venue: "AC Galleries · Home of Colorado Artists",
      note: "June 4 – August 23, 2026",
    },
    {
      year: "2026",
      title: "Black Futures In Art — Genome Speaks What Erasure Cannot Silence",
      venue: "Lafayette Arts & Cultural Resources · 201 N. Public Rd, Lafayette, CO",
      note: "May 14 – July 12, 2026 · In partnership with Climate Justice Hive",
    },
    {
      year: "2025",
      title: "Not Another Black Art Show",
      venue: "Niza Knoll Gallery · 915 Santa Fe Dr, Denver, CO",
      note: "May 30 – June 29, 2025 · Artist panel discussion",
    },
    {
      year: "2025",
      title: "High Noon",
      venue: "Memento Mori Gallery · 6451 W Colfax Ave, Lakewood, CO",
      note: "Jan 3 – 25, 2025",
    },
    {
      year: "2025",
      title: "BHM — Black History Month Group Show",
      venue:
        "Charlie Cousins Gallery · Blair-Caldwell African American Research Library · Denver, CO",
      note: "Feb 5 – Mar 11, 2025",
    },
  ],
  permanentInstallations: [
    {
      year: "2026",
      title: '"Dearfield" mural · Jackson Lake State Park entrance station',
      venue: "Colorado Parks & Wildlife · Orchard, CO",
      note: "Unveiled 2026 by Governor Jared Polis · Colorado 150 statehood celebration",
    },
    {
      year: "2025",
      title: '"Mile High Maverick" (48"×48") and "Sunrise Ryder" (48"×48")',
      venue: "Clayton Hotel & Members Club · 2nd Floor · Denver, CO",
      note: "Currently on display · Available by inquiry",
    },
  ],
  recognition: [
    {
      year: "2026",
      title: "Colorado 150 — Dearfield Mural Unveiling",
      detail:
        "Mural at Jackson Lake State Park honoring the Dearfield homesteading colony, unveiled by Governor Jared Polis as part of Colorado's 150th statehood celebration",
    },
    {
      year: "2024",
      title: "BRIC 5 Year Anniversary",
      detail:
        "Commissioned framed prints presented to Anthony Anderson and Dallas Jackson at the Black Resilience in Colorado 5 Year Anniversary",
    },
    {
      year: "2024",
      title: "Featured Artist — Cherry Creek Magazine",
      detail: '"Artist in Residence" feature',
    },
  ],
  galleriesShown: [
    "SeeSaw Gallery — Englewood, CO",
    "Niza Knoll Gallery — Denver, CO",
    "Mae's Gallery — Denver, CO",
    "Charlie Cousins Gallery — Denver, CO",
    "D'Art Gallery — Santa Fe Arts District, Denver, CO",
    "Vida Ellison Gallery — Denver, CO",
    "Cottonwood Gallery — Denver, CO",
    "Memento Mori Gallery — Lakewood, CO",
    "Tonantzin Casa De Café — Denver, CO",
    "Niza Knoll Gallery — Denver, CO",
    "Dairy Arts Center · McMahon Gallery — Boulder, CO",
    "Clayton Hotel & Members Club — Denver, CO",
  ],
  press: [
    {
      outlet: "North Forty News",
      title: "Colorado 150 Art Honors Mountains, Dearfield",
      year: "2026",
      link: "https://northfortynews.com/category/art-lifestyle/colorado-150-art-honors-mountains-dearfield/",
    },
    {
      outlet: "Daily Camera",
      title: "Black Futures in Art 2026 at Dairy Arts Center",
      year: "2026",
      link: "https://www.dailycamera.com/2026/02/28/black-futures-in-art-dairy-arts-center-boulder/",
    },
    {
      outlet: "DARIA — Denver Art Review, Inquiry & Analysis",
      title: "In Plain Sight: a celebration of Black cowboys",
      year: "2025",
      link: "https://www.dariamag.com/home/in-plain-sight",
    },
    {
      outlet: "Cherry Creek Magazine",
      title: "Artist in Residence: Meet Joseph Graves, Jr.",
      year: "2024",
      link: "https://cherrycreekmag.com/artist-in-residence-2/",
    },
    {
      outlet: "Shoutout Colorado",
      title: "Meet Joseph Graves · Artist & Educator",
      year: "2025",
      link: "https://shoutoutcolorado.com/meet-joseph-graves-artist-educator/",
    },
  ],
  professional: [
    {
      year: "2014 – 2017",
      role:
        "Director of Constituent Services · Office of Colorado Governor John Hickenlooper",
    },
    {
      role:
        "Policy Analyst & Outreach Director · Colorado State Senate",
    },
    {
      role: "Legal Administrator · Denver Water",
    },
  ],
  teachingAndPractice: [
    "Educator in digital arts and design — mentoring students in creativity and visual storytelling",
    "Live event painting · Denver, CO and regional",
    "Daddy Joe's Cowboy Capers — youth programming connecting craft, story, and Western heritage",
    "Studio Member · Art District on Santa Fe / D'Art Gallery",
    "Featured Artist · RiNo Art District",
    "Award-winning actor, writer, acting coach, and singer",
  ],
  representation:
    "Represented by SeeSaw Gallery · Englewood, CO. Listed on Artsy.",
};
